import React from "react";
import Mechelenlogo from "../../assets/imgs/Mechelen_logo.svg";
import VlaanderenLogo from "../../assets/imgs/VlaanderenLogo.jpg";
import ArcoLogo from "../../assets/imgs/arcoLogo.png";
import "./FooterStyles.scss";

const Footer = (props) => {
  return (
    <div className='footer'>
      <div className='footer-logos'>
        <img className='footer-logo' src={Mechelenlogo} />
        <img className='footer-logo' src={VlaanderenLogo} />
        <img className='footer-logo' src={ArcoLogo} />
      </div>
      <p className='footer-credit'>
        Designed and Built by Adam Woolf @ <a href='https://www.webspinner.eu'>WebSpinner.eu</a>
      </p>
    </div>
  );
};

export default Footer;
